import { render, staticRenderFns } from "./UltimosImoveisAluguel.vue?vue&type=template&id=4d524230&"
import script from "./ultimosImoveisAluguel.js?vue&type=script&lang=js&"
export * from "./ultimosImoveisAluguel.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports